<template>
    <NavBar color="#343A41" bgcolor="white">
        <template v-slot:title>
            <span class="nav-title">我的藏品</span>
        </template>
    </NavBar>
    <div class="box" :class="{blue: type != 'available'}">
        <div class="tab" :class="{new_year_tab: $newYearStyle}">
            <div class="item" :class="{active: type == 'available'}" @click="changeType('available')">可投递的</div>
            <div class="item" :class="{active: type == 'receive'}" @click="changeType('receive')">我收到的</div>
            <div class="item" :class="{active: type == 'send'}" @click="changeType('send')">我投递的</div>
        </div>
        <div class="list" @scroll="scroll">
            <div class="item" :class="{available: type == 'available', new_year_tab: $newYearStyle}" v-for="item in entities" :key="item.id">
                <img :src="item.cover" class="cover">
                <div class="info">
                    <p class="title">{{item.name}}</p>
                    <p class="subtitle number">藏品编号：<span>{{item.number}}</span></p>
                    <p class="subtitle">投递时间：<span>{{item.time ? dateFormat('YYYY.mm.dd', item.time) : ''}}</span></p>
                    <p class="subtitle">区块链地址：<span>{{item.address ? item.address.replace(/([\S\s]{10})[\S\s]+([\S\s]{4})/, "$1****$2") : ''}}</span></p>
                </div>
                <router-link :to="'/delivery/submit?entity_id=' + item.id" class="button">心意投递</router-link>
            </div>
        </div>
        <div v-show="! loading && entities.length <= 0" class="list-null">
            <van-empty
                :image="require('@/assets/images/kong.png')"
                description="暂无数据"
                v-if="!$newYearStyle"/>
            <van-empty
                :image="require('@/assets/images1/newYear/kong.png')"
                description="暂无数据"
                v-else/>
        </div>
    </div>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>